import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title (t \'Choose plant\')}}\n\n<Page::SelectLocation />")